import Head from './../components/Head';
import dayjs from 'dayjs';
import Footer from '../components/Footer.vue';
import { Empty } from 'zhs-components';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import { handleLogin, handleLogout, getUrlParams, getLoginUrl } from '@/plugins/utils';
import { getStorage } from '@/plugins/store';
import BannerTemplate from './components/BannerTemplate.vue';
import ClassroomTemplate from './components/ClassroomTemplate.vue';
import Quality from './components/Quality.vue';
export default {
  created() {
    this.getNewsTypeList();
    this.getNewsList(); // this.getNewsClassNew()
  },

  components: {
    Head,
    Footer,
    Empty,
    BannerTemplate,
    ClassroomTemplate,
    Quality
  },

  data() {
    return {
      loading: false,
      locale: zhCn,
      activeTab: 'home',
      menuId: this.$utils.getUrlParams('menuId'),
      newsList: [],
      newsTypeList: [],
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 12,
        newsTypeId: ''
      },
      newsName: '',
      showSearchResult: false,
      title: '',
      menuInfo: {},
      roleType: '',
      isLogin: null,
      showNone: false,
      zhsRole: 0,
      userInfo: {},
      sortValue: ''
    };
  },

  provide() {
    return {
      defaultImg: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202509/3135300121e144969f6688e6a4e2c40e.jpg'
    };
  },

  watch: {
    menuInfo(newVal) {
      this.menuInfo = newVal;
      console.log('menuInfo', this.menuInfo);
      this.roleType = this.menuInfo.roleType;

      if (this.menuInfo.layout === 1) {
        this.sortValue = '1';
      }

      this.getPession();
    },

    isLogin(val) {
      this.isLogin = val; //true 登录  false 没登录

      this.getPession();
    }

  },
  computed: {
    needPagination() {
      return this.pageInfo.rows > this.pageInfo.pageLimit;
    },

    schoolId() {
      const res = getStorage('projectBaseData');
      return res.school_id ? res.school_id : 0;
    }

  },
  methods: {
    handleLogin,

    formatDay(timeStr) {
      if (!timeStr) return '';
      return timeStr.split(' ')[0].split('/')[2];
    },

    // 解析日期 - 月
    formatMonth(timeStr) {
      if (!timeStr) return '';
      return timeStr.split(' ')[0].split('/')[1];
    },

    // 解析日期 - 年
    formatYear(timeStr) {
      if (!timeStr) return '';
      return timeStr.split(' ')[0].split('/')[0];
    },

    getPession() {
      if (!this.isLogin && this.roleType.includes('0')) {
        this.showNone = true;
      } else if (this.isLogin && this.roleType.includes(this.zhsRole)) {
        this.showNone = true;
      } else {
        this.showNone = false;
      }
    },

    getUserInfo(data) {
      this.userInfo = data; // this.uuid = data.uuid
      // this.userId = data.id
    },

    getZhsRole(data) {
      this.zhsRole = data || 0; // this.zhsRole = 1
    },

    handleSortChange(val) {
      this.sortValue = val;
      this.getNewsList();
    },

    async getNewsTypeList() {
      const newsTypeList = await this.$http.getNewsClass({
        menu_id: this.menuId
      });
      this.newsTypeList = newsTypeList;
      console.log('newsTypeList', this.newsTypeList);
    },

    // async getNewsClassNew() {
    //   const newsClassList = await this.$http.getNewsClassListById({
    //     menu_id: this.menuId
    //   })
    // },
    async getNewsList() {
      this.loading = true;

      try {
        const params = {
          '_pageable.page': this.pageInfo.pageIndex - 1,
          '_pageable.size': this.$utils.getUrlParams('name') === '智教讲堂' ? this.pageInfo.pageLimit : 1000,
          menu_id: this.menuId,
          news_name: this.newsName || undefined,
          classify_id: this.pageInfo.newsTypeId || undefined,
          order: this.sortValue || undefined
        };
        const res = await this.$http.getNewsList(params);
        this.newsList = res.content;
        this.pageInfo.rows = +res.totalElements;
      } finally {
        this.loading = false;
      }
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getNewsList();
    },

    handleSizeChange(newSize) {
      this.pageInfo.pageLimit = newSize;
      this.pageInfo.pageIndex = 1; // 重置页码为第一页

      this.getNewsList(); // 重新加载数据
    },

    handleTabClick(tab) {
      // 映射到原有逻辑
      const newsTypeId = this.activeTab === 'home' ? '' : this.activeTab;
      this.handleSearch(newsTypeId);
    },

    handleClear() {
      // 清空搜索条件
      this.courseName = ''; // 调用接口刷新数据

      this.getNewsList();
    },

    // 搜索
    handleSearch(newsTypeId = '') {
      this.pageInfo.pageIndex = 1;
      this.pageInfo.newsTypeId = newsTypeId;
      this.getNewsList();
      this.showSearchResult = true;
    },

    // 关键字高亮
    kewordFilter(value) {
      if (!value) return '';
      if (!this.newsName) return value;
      let reg = new RegExp(this.newsName, 'g');
      return value.replace(reg, `<span class="theme-color">${this.newsName}</span>`);
    },

    // 格式化新闻内容
    formateNews(data) {
      let result = this.$utils.getContentText(data);
      return this.kewordFilter(result);
    },

    // 增加观看次数
    async addViewCount(id) {
      const res = await this.$http.addViewCount({
        id
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    },

    // 点击卡片进去详情页
    showNewsDetail(item) {
      if (this.schoolId == 795) {
        const scope = item.scope || 0; // 未登录状态下，选择非公开范围时，阻止切换并跳转登录

        if (scope > 0 && this.zhsRole == 0) {
          this.handleLogin();
          return false; // 阻止切换
        } // 角色为老师时,选择学生可见时，阻止切换


        if (scope == 2 && this.zhsRole == 2) {
          ElMessage.warning('该记录仅学生可访问，请查看其他内容');
          return false; // 阻止切换
        } // 角色为学生时,选择老师可见时，阻止切换


        if (scope == 1 && this.zhsRole == 3) {
          ElMessage.warning('该记录仅教师可访问，请查看其他内容');
          return false; // 阻止切换
        }
      }

      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?id=${item.id}&menuId=${this.menuId}&name=${this.menuInfo.nav_name}&classify=${item.classify_name || ''}`;
      } else {
        this.addViewCount(item.id);
        window.open(item.news_url);
      }
    },

    dayjs
  }
};